import PropTypes from "prop-types";

function GoTo({ target, hideType = false, short = false, type = false }) {
  if (target && Object.keys(target).length > 0) {
    if (short) {
      return target?.name ?? "None";
    } else if (type) {
      return target?.type ?? "None";
    } else {
      return `${[target?.exten, target?.name].filter(Boolean).join(" \u00b7 ")}${!hideType && target?.type ? ` (${target.type})` : ""}`;
    }
  }

  return "None";
}

GoTo.propTypes = {
  target: PropTypes.object,
  short: PropTypes.bool,
  hideType: PropTypes.bool,
  type: PropTypes.bool,
};

export default GoTo;
